export const AIR_SELECTED = 'pk_sel_a';
export const RATE_ID = 'pk_sel_rt_h';
export const PACKAGE_BASE_URL_RESULT = 'pk_ret_pt';
export const SEARCH_PK = 'pk_ser_plad';

export const DETAIL_PACKAGE_STEP = 'package_step';
export const RESULT_PACKAGE_STEP = 'step';
